<template>
  <div class="bootcamp-materials-instructions">
    <p
      class="bootcamp-materials-instructions__description"
      v-html="instructions"
    ></p>
  </div>
</template>

<script>
export default {
  name: 'Instructions',
  props: {
    instructions: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.bootcamp-materials-instructions {
  &__description {
    font-size: rem(16px);
    color: var(--white);
  }
  &__subtitle {
    font-size: rem(18px);
    color: var(--orange);
    text-transform: uppercase;
    margin: 25px 0;
  }
  &__step-list {
    margin: 0;
    padding: 0 0 0 25px;
  }
  &__step {
    font-size: rem(16px);
    color: var(--white);
  }
}
</style>
